module.exports = "/images/id-step2ja.png?8bd5569dfae7084711245e7043ec4205";